import { FilterProvidersToken, IFilterProvider } from '@irian-ro/table-column-filter';
import { textInputFactory } from './input-filter/input-text-factory';
import { dateRangeInputFactory } from './date-range/date-range-factory';
import { InputFilterComponent } from './input-filter/input-filter.component';
import { DateRangeComponent } from '@irian-ro/shared-components-module';
import { DropdownFilterComponent } from './dropdown-filter/dropdown-filter.component';
import { dropdownFilterFactory } from './dropdown-filter/dropdown-filter-factory';
import { calendarFactory } from './calendar-filter/calendar-factory';
import { DateTableFilterComponent } from './calendar-filter/date-table-filter/date-table-filter.component';
import { MultiselectFilterComponent } from './multiselect-filter/multiselect-filter/multiselect-filter.component';
import { multiselectFilterFactory } from './multiselect-filter/multiselect-filter-factory';
import { DateTimeRangeContextMenuFilterComponent } from './date-time-range-context-menu-filter/date-time-range-context-menu-filter.component';
import {
  dateTimeRangeContextMenuFactory
} from './date-time-range-context-menu-filter/date-time-range-context-menu-factory';

export const filtersProviders = [
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<InputFilterComponent>>{
      type: 'input',
      factory: textInputFactory,
    },
    multi: true,
  },
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<DateRangeComponent>>{
      type: 'date-range',
      factory: dateRangeInputFactory,
    },
    multi: true,
  },
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<DropdownFilterComponent>>{
      type: 'dropdown',
      factory: dropdownFilterFactory,
    },
    multi: true,
  },
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<DateTableFilterComponent>>{
      type: 'calendar',
      factory: calendarFactory,
    },
    multi: true,
  },
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<MultiselectFilterComponent>>{
      type: 'multiselect',
      factory: multiselectFilterFactory,
    },
    multi: true,
  },
  {
    provide: FilterProvidersToken,
    useValue: <IFilterProvider<DateTimeRangeContextMenuFilterComponent>> {
      type: 'date-time-range',
      factory: dateTimeRangeContextMenuFactory
    },
    multi: true,
  }
];
